import { type ReactElement } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { RouteGround } from "@/components/shared/RouteGround";
import {
  APP_TO_SAVE_ORGANIZE_SOCIAL_POSTS,
  BLOG,
  BLOG_CATEGORY,
  BLOG_POST,
  COMPARE,
  CHATGPT_CONNECT,
  CHATGPT_CONNECTIONS,
  DECK,
  FAQ,
  INVITE_LANDING,
  LANDING_PAGE,
  LOGIN,
  MOBILE_APP_LANDING,
  ORGANIZE_SAVED_REELS,
  PRIVACY,
  RECIME_ALTERNATIVE,
  RESET,
  RESET_PASSWORD,
  ROOT,
  SAVE_EVENTS_FROM_INSTAGRAM_TIKTOK,
  SAVE_GIFT_IDEAS_FROM_SOCIAL_MEDIA,
  SAVE_PLACES_FROM_TIKTOK,
  SAVE_RECIPES_FROM_INSTAGRAM_TIKTOK,
  SAVE_TIKTOKS,
  SAVE_TRAVEL_IDEAS_FROM_INSTAGRAM_TIKTOK,
  SIGNUP,
  STACKLIST_ALTERNATIVE,
  TERMS,
  UNSUBSCRIBE,
  VERIFY_EMAIL,
} from "@/routes";

type RouteFallbackElement = ReactElement | null;

// Public/marketing routes paint their own first frame — no ground.
const PUBLIC_NO_FALLBACK_ROUTE_PATTERNS = [
  ROOT(),
  LANDING_PAGE(),
  LOGIN(),
  SIGNUP(),
  INVITE_LANDING(),
  MOBILE_APP_LANDING(),
  DECK(),
  FAQ(),
  TERMS(),
  PRIVACY(),
  CHATGPT_CONNECT(),
  CHATGPT_CONNECTIONS(),
  BLOG(),
  BLOG_CATEGORY(),
  BLOG_POST(),
  APP_TO_SAVE_ORGANIZE_SOCIAL_POSTS(),
  SAVE_PLACES_FROM_TIKTOK(),
  ORGANIZE_SAVED_REELS(),
  SAVE_TIKTOKS(),
  SAVE_RECIPES_FROM_INSTAGRAM_TIKTOK(),
  SAVE_TRAVEL_IDEAS_FROM_INSTAGRAM_TIKTOK(),
  SAVE_EVENTS_FROM_INSTAGRAM_TIKTOK(),
  SAVE_GIFT_IDEAS_FROM_SOCIAL_MEDIA(),
  RECIME_ALTERNATIVE(),
  STACKLIST_ALTERNATIVE(),
  COMPARE(),
  RESET(),
  RESET_PASSWORD(),
  VERIFY_EMAIL(),
  UNSUBSCRIBE(),
];

function getRouteFallbackElement(pathname: string): RouteFallbackElement {
  const isPublic = PUBLIC_NO_FALLBACK_ROUTE_PATTERNS.some(path =>
    matchPath({ path, end: true }, pathname),
  );
  return isPublic ? null : <RouteGround />;
}

export function RoutePatternFallback({ path }: { path: string }) {
  return getRouteFallbackElement(path);
}

export function CurrentRouteFallback() {
  const location = useLocation();
  return getRouteFallbackElement(location.pathname);
}
